import { css, withStyles } from '@recruit-robin/robin-theme/web-styles';

export const useStyles = withStyles({
  autoSendInviteCard: ({ theme }) => css`
    width: 100%;
    display: flex;
    gap: 16px;
    padding: 12px 16px;
    border-radius: 8px;
    justify-content: flex-start;
    user-select: none;
    cursor: pointer;

    transition:
      background-color 150ms ease,
      border-color 150ms ease,
      box-shadow 150ms ease;

    &:hover {
      background-color: ${theme.colors.neutral.variant[5]};
      border-color: ${theme.colors.neutral.variant[20]};
    }
  `,
  autoSendInviteCardEnabled: ({ theme }) => css`
    background-color: ${theme.colors.neutral.variant[0]};
    border: 1px solid ${theme.colors.neutral.variant[20]};
  `,
  autoSendInviteCardDisabled: ({ theme }) => css`
    background-color: ${theme.colors.neutral.variant[10]};
    border: 1px solid ${theme.colors.neutral.variant[10]};
  `,
  autoSendInviteCheckbox: css`
    padding-top: 4px;
    flex-shrink: 0;
  `,
  autoSendInviteContent: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
    max-width: 100%;
    min-width: 0;
  `,
  autoSendInviteInterviewType: ({ theme }) => css`
    margin-left: auto;
    margin-right: -12px;

    &:hover {
      background-color: ${theme.colors.neutral.variant[20]};
    }
  `,
  autoSendInviteHeader: css`
    display: flex;
    align-items: center;
    gap: 8px;
    max-width: 100%;

    svg {
      flex-shrink: 0;
    }
  `,
});
